const ABObject = require("./ABObject");
module.exports = class ABObjectImport extends ABObject {};
